import { action } from 'typesafe-actions';
import { IIntegration, IIntegrationLocation } from 'types';
import { Integration } from './types';

export const getIntegrationRequest = (siteId: string, integrationId: string) => action(Integration.GET_INTEGRATION_REQUEST, { siteId, integrationId });
export const getIntegrationSucess = (response: IIntegration) => action(Integration.GET_INTEGRATION_SUCCESS, response);
export const getIntegrationError = (error: any) => action(Integration.GET_INTEGRATION_FAIL, error);

export const getIntegrationLocationRequest = (siteId: string, integrationId: string) => action(Integration.GET_INTEGRATION_LOCATION_REQUEST, { siteId, integrationId });
export const getIntegrationLocationSuccess = (response: IIntegrationLocation) => action(Integration.GET_INTEGRATION_LOCATION_SUCCESS, response);
export const getIntegrationLocationError = (error: any) => action(Integration.GET_INTEGRATION_LOCATION_FAIL, error);
